"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkCompanyMetaData = exports.isCompanyMetaData = void 0;
const Check_1 = require("../check/Check");
function isCompanyMetaData(object) {
    return checkCompanyMetaData(object).fulfilled;
}
exports.isCompanyMetaData = isCompanyMetaData;
function checkCompanyMetaData(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, Check_1.check)(object, (0, Check_1.hasString)("companyId"), (0, Check_1.hasArray)("internalUserIds", (0, Check_1.isString)()), (0, Check_1.hasArray)("externalUserIds", (0, Check_1.isString)()).optional(), (0, Check_1.hasMap)("userMetaData", (0, Check_1.isRecord)((0, Check_1.hasString)("name"), (0, Check_1.hasChoice)("status", ["active", "inactive"])))).withOptions(options).explain();
}
exports.checkCompanyMetaData = checkCompanyMetaData;
//# sourceMappingURL=CompanyMetaData.js.map